// @flow

/* eslint-disable import/prefer-default-export */
import jsCookie from 'js-cookie';
import jsHttpCookie from 'cookie';

import type { AccessToken, CookieFlag } from './types';

const hasCookie = req => req.headers && req.headers.cookie;

export const getAccessToken = (req: ?Object): AccessToken => {
  const isServer = !!req;

  let accessToken: string = '';

  if (isServer) {
    if (req && hasCookie(req)) {
      // eslint-disable-next-line prefer-destructuring
      accessToken = jsHttpCookie.parse(req.headers.cookie).accessToken;
    }
  } else {
    accessToken = jsCookie.get('accessToken');
  }

  return accessToken;
};

export const getCookieConsent = (): CookieFlag => {
  const dismissed = jsCookie.get('cookieConsent');

  return {
    dismissed,
    dismiss: () => {
      jsCookie.set('cookieConsent', true, { expires: 365 });
    }
  };
};

export const getProfileAlertDismissed = (): CookieFlag => {
  const dismissed: boolean = jsCookie.get('profileAlertDismissed') || false;

  return {
    dismissed,
    dismiss: () => {
      jsCookie.set('profileAlertDismissed', true, { expires: 365 });
    }
  };
};
